<div class="brk-form-date-wrap brk-form-date-wrap--labeled brk-form-wrap-active">
  <input
    [id]="inputId"
    class="brk-form-date rendered"
    name="dataNascimento"
    type="text"
    placeholder="dd/mm/aaaa"
    inputmode="numeric"
    [attr.autocomplete]="autocomplete"
    [value]="value"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [attr.readonly]="readonly || isDisabled ? true : null"
    aria-label="Data de nascimento">
  <label class="input-label" [for]="inputId">Data de nascimento</label>
  <span class="icon-before">
    <i class="fa fa-calendar" aria-hidden="true"></i>
  </span>
</div>
